import Vue from 'vue'
import RavenVue from 'raven-js/plugins/vue'

// Raven must me initialized before the other modules
window.Raven.addPlugin(RavenVue, Vue).install()

import * as shim from 'es6-shim' // eslint-disable-line no-unused-vars
import { requestAnimationFrame, cancelAnimationFrame } from 'animation-frame-polyfill' // eslint-disable-line no-unused-vars
import { initStorage, storage } from '@/assets/storage'
import * as orientationChangeEnd from 'orientationchangeend'

orientationChangeEnd({}).on('orientationchangeend', () => {
  window.dispatchEvent(new Event('resize'))
})

// import FastClick from 'fastclick'
// FastClick.attach(document.body)

window.promptAsync = function (content, callback) {
  const result = window.prompt(content) // eslint-disable-line no-alert
  callback(result)
}

window.confirmAsync = function (content, callback) {
  const result = window.confirm(content) // eslint-disable-line no-alert
  callback(result)
}

window.openLink = function (url) {
  window.open(url)
}

const loadCachedApp = () => {
  if (!('cordova' in window)) return false
  const cacheUrl = storage.getItem('cacheUrl')
  const currentLocation = window.location.href.replace(/\/?#.*/, '')
  // alert(cacheUrl) // eslint-disable-line
  // alert(currentLocation) // eslint-disable-line
  if (cacheUrl !== null && cacheUrl !== currentLocation) {
    window.location.replace(cacheUrl)
    return true
  }
  return false
}

window.portalLink = function (endpoint) {
  let link = ''
  const locale = Vue.config.language
  if (['fr', 'de', 'it', 'es', 'nl'].indexOf(locale) === -1) {
    link = `https://portal.meteo-parapente.com/${endpoint}`
  } else {
    link = `https://portal.meteo-parapente.com/${locale}/${endpoint}`
  }
  return link // + '?from=' + encodeURIComponent(document.location.href)
}

import router from '@/routes'
import locale from '@/locale'
import http from '@/resources/http'
import store from '@/store'
import filter from '@/filters'

import App from '@/routes/app/template'

const launchApp = function () {
  if (loadCachedApp()) return

  new Vue({
    el: 'mtopara2-app',
    components: { App },
    render: h => h('app'),
    router: router(),
    locale: locale(),
    http: http(),
    store: store(),
    filter: filter()
  })

  window.Vue = Vue
}

if (
  window.location.hostname === 'meteo-parapente.com' ||
  window.location.hostname === 'www.meteo-parapente.com' ||
  window.location.hostname === 'dev.meteo-parapente.com' ||
  window.location.port === '3000'
) {
  initStorage(e => {
    throw e
  }, launchApp)
} else {
  document.addEventListener('deviceready', () => initStorage(console.error, launchApp))
  const script = document.createElement('script')
  script.src = 'cordova.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
}



// WEBPACK FOOTER //
// ./src/index.js